import { useSelector } from 'react-redux'
import { checkIsAuthenticated } from '../lib/auth'

export const useIsAuthenticated = () => {
  const isAuthenticated = useSelector(state => checkIsAuthenticated(state))
  return isAuthenticated
}
